import ShimmerSocialPost from "./SocialPost";

export default ShimmerSocialPost;
